(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const bindHeaderAnnouncementTransitions = () => {
    document
      .querySelectorAll('swiper-container[data-404-header-part="announcement"]')
      .forEach((announcementBar) => {
        if (announcementBar.dataset.announcementTransitionsBound === 'true') {
          return;
        }

        announcementBar.dataset.announcementTransitionsBound = 'true';
        announcementBar.addEventListener(
          'swiperslidechange',
          () => {
            announcementBar.dataset.announcementTransitions = 'true';
          },
          { once: true }
        );
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      bindHeaderAnnouncementTransitions,
      { once: true }
    );
  } else {
    bindHeaderAnnouncementTransitions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  (() => {
    const supportText = 'Customer Support';

    const openGorgiasChat = () => {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
      }
    };

    const getMaintenanceSections = (root) => {
      if (root.matches && root.matches('.password-maintenance')) {
        return [root];
      }

      return Array.from(root.querySelectorAll('.password-maintenance'));
    };

    const injectSupportChatTrigger = (root = document) => {
      getMaintenanceSections(root).forEach((section) => {
        if (section.dataset.supportChatEnabled !== 'true') {
          return;
        }

        const message = section.querySelector('.password-maintenance__message');
        if (!message || message.querySelector('.password-maintenance__support-chat')) {
          return;
        }

        const walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
        let textNode = walker.nextNode();

        while (textNode) {
          const supportTextIndex = textNode.nodeValue.indexOf(supportText);
          if (supportTextIndex !== -1) {
            textNode.splitText(supportTextIndex + supportText.length);
            const supportTextNode = textNode.splitText(supportTextIndex);
            const supportButton = document.createElement('button');

            supportButton.className = 'password-maintenance__support-chat';
            supportButton.type = 'button';
            supportButton.textContent = supportText;
            supportButton.setAttribute('aria-label', section.dataset.supportChatLabel || supportText);
            supportTextNode.parentNode.replaceChild(supportButton, supportTextNode);
            return;
          }

          textNode = walker.nextNode();
        }
      });
    };

    document.addEventListener('click', (event) => {
      const supportTrigger = event.target.closest('.password-maintenance__support-chat');
      if (!supportTrigger) {
        return;
      }

      event.preventDefault();
      openGorgiasChat();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => injectSupportChatTrigger());
    } else {
      injectSupportChatTrigger();
    }

    document.addEventListener('shopify:section:load', (event) => {
      injectSupportChatTrigger(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
